import React, { useMemo } from 'react';

import { useAppConfigContext } from '../../hooks/useAppConfigContext';

import styles from './Portfolio.module.css';
import { DraftCard } from '../ProjectCard/DraftCard';
import { ProjectCard } from '../ProjectCard/ProjectCard';

export const Portfolio = ({ paddingCalc }: any) => {
  const { projects, draftProject } = useAppConfigContext();

  const sortedProjects = useMemo(
    () => projects.sort((a, b) => +a.num - +b.num),
    [projects],
  );

  const isEvenProjects = sortedProjects.length % 2 === 0;

  return (
    <section className={styles.container} style={paddingCalc}>
      <nav>
        <ul className={styles.list}>
          {sortedProjects.map((project) => {
            return (
              <li className={styles.cardBox} key={project.id}>
                <ProjectCard project={project} />
              </li>
            );
          })}
          {!isEvenProjects && (
            <li className={styles.cardBox} key="draftProject">
              <DraftCard project={draftProject} />
            </li>
          )}
        </ul>
      </nav>
    </section>
  );
};
